import { OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { ApiProperty } from '@nestjs/swagger';

export class LotNumberRequest {
  @ApiProperty()
  plant: number;
  @ApiProperty()
  operation?: OperationTypeEnum;
  @ApiProperty()
  tabName?: OperationTypeEnum
}
